// Default values per scenario type (letter 111, Comment Set #3 item 3; Agent or Wholesaler Fee and Seller
// Credits 0 from letter 115) -- a mirror of
// reilm-be/modules/properties/flipDefaults.js, which is what a new scenario is actually created with.
// README.md ("Default values by scenario type").
const SHARED_DEFAULTS = {
  // Loan Costs
  financed_down_payment1: 20,
  rehab_financed: 100,
  interest_rate: 12,
  origination_points0: 2,
  service_fees: 0,
  // Acquisition Costs
  inspection_costs: 0,
  agent_commission1: 0,
  insurance_policy1: 0.75,
  earnest_money: 5000,
  // Holding Costs
  financed_draw_fee: 0,
  utilities0: 250,
  holding_hoa_fee1: 0,
  // Selling Costs
  marketing2: 0,
  selling_commission0: 5,
  concessions_to_buyer1: 0,
  sell_other2: 0,
  // Timeline (months)
  holding_period: 6,
}

export const FLIP_DEFAULT_VALUES = Object.freeze({
  cash: Object.freeze({ ...SHARED_DEFAULTS, title_fees1: 0.8 }),
  loan: Object.freeze({ ...SHARED_DEFAULTS, title_fees1: 1.1 }),
})

// Seed values for a scenario that does not exist yet -- mirrors model.js's defaults for the fields
// these four sections read, not the whole flipAnalysisSchema. Literal defaults only, never derived --
// see README.md ("flipAnalysis: [] is the normal case").
export const DEFAULT_SCENARIO = {
  // Several formulas branch on "loan" vs "cash" (calcTotalCashToClose among them) -- included even
  // though no section renders its own scenario-type control yet.
  scenarioType: 'cash',
  // The cash column, as the backend schema's own defaults: this object is typed cash.
  ...FLIP_DEFAULT_VALUES.cash,
  purchase_price: 0,
  rehab_costs: 0,
  // No row edits this (Flip Summary's "Overbudget" row is removed), but calcAllIn, calcNetProfit and
  // all four calcScore weights still take it as a parameter -- see README.md ("Overbudget is removed
  // from the UI, not from the formula core").
  overbudget: 0,
  arv: 0,
  purchase_date: '',
  sales_date: '',
  agent_commission2: 0,
  insurance_policy2: 0,
  title_fees2: 0,
  buy_property_tax1: 0,
  // null, as sell_property_tax0: blank means the seller's computed tax share, a stored 0 is a typed $0.
  buy_seller_credits: null,
  financed_down_payment2: 0,
  interest_type: 'Non-Dutch',
  origination_points1: 0,
  utilities1: 0,
  holding_hoa_fee2: 0,
  // 24-slot override array for the expanded Projected Interest panel's payment rows
  // (ProjectedInterestPanel.jsx) -- model.js's own default is `Array(24).fill(0)`.
  paySchedProrations: Array(24).fill(0),
  sell_tax_applied: 'hold',
  selling_commission1: 0,
  concessions_to_buyer2: 0,
  // null, not model.js's old 0: a blank override is what makes the backend compute the proration
  // from the dates, and a stored 0 is a real override of $0 (verification-runs, logic-auditor HIGH).
  sell_property_tax0: null,
  // Refinance Summary's own %/$ toggle pair (RefinanceSummarySection.jsx) -- mirrors model.js's own
  // schema defaults (65/0/3/0), same rule as every other field in this file.
  br4_ltv1: 65,
  br4_ltv2: 0,
  br4_loan_cost1: 3,
  br4_loan_cost2: 0,
  // Sales Proceeds panel's own two editable rows (SalesProceedsPanel.jsx) -- mirrors
  // reilm-be/modules/properties/model.js:121-122, default 0 there too.
  tax_out_of_pocket: 0,
  drawn_funds: 0,
  toggles: {},
}
